/**
 * Redux Store Hooks
 * Pre-typed hooks for use throughout the application
 */

import type { AppDispatch, RootState } from "@/store";
import { useDispatch, useSelector } from "react-redux";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
